import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../js/coreRuntime.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../Unit.mjs';
import { EmptyIterator_instanceqrxhm096rah7 as EmptyIterator_instance } from './CollectionsKt.mjs';
import { iterator3f5i676wpaa3g as iterator } from '../sequences/SequenceBuilder.mjs';
import { AbstractIterator1svf7vpi1lw8y as AbstractIterator } from './AbstractIterator.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import {
  AbstractList3ck35puwbp1e9 as AbstractList,
  Companion_instance1el8xrhi64v9a as Companion_instance,
} from './AbstractList.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import { isArray1hxjqtqy632bc as isArray } from '../js/typeCheckUtils.mjs';
import {
  copyOf2ng0t8oizk6it as copyOf,
  fill3hcjvebk42tyx as fill,
} from './_ArraysJs.mjs';
import { terminateCollectionToArray12671uhv05xea as terminateCollectionToArray } from './collectionJs.mjs';
import { coerceAtMost322komnqp70ag as coerceAtMost } from '../ranges/_Ranges.mjs';
import { RandomAccess1jbw8sdogqb8x as RandomAccess } from './RandomAccess.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from './ArrayListJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function checkWindowSizeStep(size, step) {
  // Inline function 'kotlin.require' call
  if (!(size > 0 && step > 0)) {
    var message = !(size === step) ? 'Both size ' + size + ' and step ' + step + ' must be greater than zero.' : 'size ' + size + ' must be greater than zero.';
    throw IllegalArgumentException().n2(toString(message));
  }
}
function windowedIterator(iterator_0, size, step, partialWindows, reuseBuffer) {
  if (!iterator_0.q1())
    return EmptyIterator_instance;
  return iterator(windowedIterator$slambda(size, step, iterator_0, reuseBuffer, partialWindows));
}
var RingBuffer$iterator$1Class;
function RingBuffer$iterator$1() {
  if (RingBuffer$iterator$1Class === VOID) {
    class $ extends AbstractIterator() {
      constructor(this$0, $box) {
        if ($box === VOID)
          $box = {};
        $box.xl_1 = this$0;
        super($box);
        this.vl_1 = this$0.bm_1;
        this.wl_1 = this$0.am_1;
      }
      ri() {
        if (this.vl_1 === 0) {
          this.ti();
        } else {
          this.si(this.xl_1.yl_1[this.wl_1]);
          var tmp = this;
          var tmp0 = this.xl_1;
          // Inline function 'kotlin.collections.RingBuffer.forward' call
          tmp.wl_1 = (this.wl_1 + 1 | 0) % tmp0.zl_1 | 0;
          this.vl_1 = this.vl_1 - 1 | 0;
        }
      }
    }
    initMetadataForClass($);
    RingBuffer$iterator$1Class = $;
  }
  return RingBuffer$iterator$1Class;
}
var RingBufferClass;
function RingBuffer() {
  if (RingBufferClass === VOID) {
    class $ extends AbstractList() {
      constructor(buffer, filledSize) {
        return new.target.cm(buffer, filledSize);
      }
      static cm(buffer, filledSize) {
        var $this = this.yi();
        $this.yl_1 = buffer;
        // Inline function 'kotlin.require' call
        if (!(filledSize >= 0)) {
          var message = 'ring buffer filled size should not be negative but it is ' + filledSize;
          throw IllegalArgumentException().n2(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(filledSize <= $this.yl_1.length)) {
          var message_0 = 'ring buffer filled size: ' + filledSize + ' cannot be larger than the buffer size: ' + $this.yl_1.length;
          throw IllegalArgumentException().n2(toString(message_0));
        }
        $this.zl_1 = $this.yl_1.length;
        $this.am_1 = 0;
        $this.bm_1 = filledSize;
        return $this;
      }
      static dm(capacity) {
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp$ret$0 = Array(capacity);
        return this.cm(tmp$ret$0, 0);
      }
      q2() {
        return this.bm_1;
      }
      r2(index) {
        Companion_instance.i7(index, this.bm_1);
        // Inline function 'kotlin.collections.RingBuffer.forward' call
        var tmp$ret$0 = (this.am_1 + index | 0) % this.zl_1 | 0;
        return this.yl_1[tmp$ret$0];
      }
      em() {
        return this.bm_1 === this.zl_1;
      }
      p1() {
        return new (RingBuffer$iterator$1())(this);
      }
      xj(array) {
        var tmp;
        if (array.length < this.bm_1) {
          // Inline function 'kotlin.collections.copyOf' call
          var newSize = this.bm_1;
          tmp = copyOf(array, newSize);
        } else {
          tmp = isArray(array) ? array : THROW_CCE();
        }
        var result = tmp;
        var size = this.bm_1;
        var widx = 0;
        var idx = this.am_1;
        while (widx < size && idx < this.zl_1) {
          result[widx] = this.yl_1[idx];
          widx = widx + 1 | 0;
          idx = idx + 1 | 0;
        }
        idx = 0;
        while (widx < size) {
          result[widx] = this.yl_1[idx];
          widx = widx + 1 | 0;
          idx = idx + 1 | 0;
        }
        var tmp_0 = terminateCollectionToArray(size, result);
        return isArray(tmp_0) ? tmp_0 : THROW_CCE();
      }
      i8() {
        // Inline function 'kotlin.arrayOfNulls' call
        var size = this.bm_1;
        var tmp$ret$0 = Array(size);
        return this.xj(tmp$ret$0);
      }
      toArray() {
        return this.i8();
      }
      fm(maxCapacity) {
        var newCapacity = coerceAtMost((this.zl_1 + (this.zl_1 >> 1) | 0) + 1 | 0, maxCapacity);
        var tmp;
        if (this.am_1 === 0) {
          // Inline function 'kotlin.collections.copyOf' call
          var this_0 = this.yl_1;
          tmp = copyOf(this_0, newCapacity);
        } else {
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp$ret$1 = Array(newCapacity);
          tmp = this.xj(tmp$ret$1);
        }
        var newBuffer = tmp;
        return RingBuffer().cm(newBuffer, this.bm_1);
      }
      gm(element) {
        if (this.em()) {
          throw IllegalStateException().o('ring buffer is full');
        }
        // Inline function 'kotlin.collections.RingBuffer.forward' call
        var tmp$ret$0 = (this.am_1 + this.bm_1 | 0) % this.zl_1 | 0;
        this.yl_1[tmp$ret$0] = element;
        this.bm_1 = this.bm_1 + 1 | 0;
      }
      hm(n) {
        // Inline function 'kotlin.require' call
        if (!(n >= 0)) {
          var message = "n shouldn't be negative but it is " + n;
          throw IllegalArgumentException().n2(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(n <= this.bm_1)) {
          var message_0 = "n shouldn't be greater than the buffer size: n = " + n + ', size = ' + this.bm_1;
          throw IllegalArgumentException().n2(toString(message_0));
        }
        if (n > 0) {
          var start = this.am_1;
          // Inline function 'kotlin.collections.RingBuffer.forward' call
          var end = (start + n | 0) % this.zl_1 | 0;
          if (start > end) {
            fill(this.yl_1, null, start, this.zl_1);
            fill(this.yl_1, null, 0, end);
          } else {
            fill(this.yl_1, null, start, end);
          }
          this.am_1 = end;
          this.bm_1 = this.bm_1 - n | 0;
        }
      }
    }
    initMetadataForClass($, 'RingBuffer', VOID, VOID, [RandomAccess()]);
    RingBufferClass = $;
  }
  return RingBufferClass;
}
function windowedIterator$slambda($size, $step, $iterator, $reuseBuffer, $partialWindows) {
  return constructCallableReference(function *($this$iterator, $completion) {
    var bufferInitialCapacity = coerceAtMost($size, 1024);
    var gap = $step - $size | 0;
    var tmp;
    if (gap >= 0) {
      var buffer = ArrayList().h2(bufferInitialCapacity);
      var skip = 0;
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s = $iterator;
      $l$loop: while (_iterator__ex2g4s.q1()) {
        var e = _iterator__ex2g4s.r1();
        if (skip > 0) {
          skip = skip - 1 | 0;
          continue $l$loop;
        }
        buffer.i2(e);
        if (buffer.q2() === $size) {
          yield* $this$iterator.cl(buffer, $completion);
          if ($reuseBuffer) {
            buffer.a5();
          } else
            buffer = ArrayList().h2($size);
          skip = gap;
        }
      }
      var tmp_0;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!buffer.n1()) {
        tmp_0 = $partialWindows || buffer.q2() === $size ? (yield* $this$iterator.cl(buffer, $completion)) : void 0;
      }
      tmp = tmp_0;
    } else {
      var buffer_0 = RingBuffer().dm(bufferInitialCapacity);
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s_0 = $iterator;
      $l$loop_0: while (_iterator__ex2g4s_0.q1()) {
        var e_0 = _iterator__ex2g4s_0.r1();
        buffer_0.gm(e_0);
        if (buffer_0.em()) {
          if (buffer_0.bm_1 < $size) {
            buffer_0 = buffer_0.fm($size);
            continue $l$loop_0;
          }
          yield* $this$iterator.cl($reuseBuffer ? buffer_0 : ArrayList().j2(buffer_0), $completion);
          buffer_0.hm($step);
        }
      }
      var tmp_1;
      if ($partialWindows) {
        while (buffer_0.bm_1 > $step) {
          yield* $this$iterator.cl($reuseBuffer ? buffer_0 : ArrayList().j2(buffer_0), $completion);
          buffer_0.hm($step);
        }
        var tmp_2;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!buffer_0.n1()) {
          tmp_2 = yield* $this$iterator.cl(buffer_0, $completion);
        }
        tmp_1 = tmp_2;
      }
      tmp = tmp_1;
    }
    return Unit_instance;
  }, 1);
}
//region block: exports
export {
  checkWindowSizeStep as checkWindowSizeStepcg5bise2nnst,
  windowedIterator as windowedIterator1l52d653czu3r,
};
//endregion

//# sourceMappingURL=SlidingWindow.mjs.map
